module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('backhaul-table', {
    attrs: {
      "site-id": _vm.siteId,
      "provider": false,
      "site-data": _vm.siteData,
      "sharer-id": _vm.sharerId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-396a0d33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/sharers/BackhaulTab.vue
// module id = 1508
// module chunks = 0